import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import * as Common from "../commons/common";
import * as Request from "../commons/request";
import * as Utils from "../utils/utils";

import styles from "./UseCheckList.module.css";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { Checkbox, Divider, Row, Space } from "antd";
import PageContainer from "../layout/PageContainer";

type TypeUseCategoryEducation = {
    [key: string]: { name: string; items: Array<TypeUseEducation> };
};

type TypeUseEducation = {
    isChecked: boolean;
    name: string;
};

const UseEducationList: TypeUseCategoryEducation = {
    carInfo: {
        name: "이용 안내",
        items: [
            {
                isChecked: false,
                name: "렌트 이용 안내",
            },
            {
                isChecked: false,
                name: "운행 주의사항",
            },
            {
                isChecked: false,
                name: "매뉴얼 안내",
            },
            {
                isChecked: false,
                name: "위약금 안내",
            },
        ],
    },
    rentInfo: {
        name: "동의서",
        items: [
            { isChecked: false, name: "이용 안내 확인 동의서" },
            { isChecked: false, name: "위약금 안내 확인 동의서" },
            { isChecked: false, name: "정보 수집 동의서" },
        ],
    },
};

function UseEducation() {
    const params = useParams();
    const navigate = useNavigate();

    const [currentRentId, setCurrentRentId] = useState<number>();

    const [useCheckEducationList, setUseCheckEducationList] = useState<TypeUseCategoryEducation>();

    useEffect(() => {
        setUseCheckEducationList(JSON.parse(JSON.stringify(UseEducationList)));
    }, []);

    useEffect(() => {
        if (params.rentId) setCurrentRentId(Number(params.rentId));
    }, [params.rentId]);

    useEffect(() => {
        Utils.onEvent(Common.EVENT_NEXT_PROCESS, goToNextProcess);

        return () => {
            Utils.offEvent(Common.EVENT_NEXT_PROCESS, goToNextProcess);
        };
    }, [currentRentId]);

    const goToNextProcess = () => {
        // navigate(Common.PAGE_RENT_DETAIL + "/" + currentRentId);
        onUseRent();
    };

    const onUseRent = () => {
        requestUseRent();
    };

    const requestAxiosUseRent = async () => {
        const response = await utilAxiosWithAuth().put(Request.RENT_URL + currentRentId + Request.RENT_USE_URL);
        return response.data;
    };

    const { loading: loadingUseRent, error: errorUseRent, data: resultUseRent, execute: requestUseRent } = useAsyncAxios(requestAxiosUseRent);

    useEffect(() => {
        if (resultUseRent === null) return;
        console.log("resultUseRent", resultUseRent);
        navigate(Common.PAGE_RENT_DETAIL + "/" + currentRentId);
    }, [resultUseRent]);

    useEffect(() => {
        if (errorUseRent === null) return;
        console.log("errorUseRent", errorUseRent);
    }, [errorUseRent]);

    const setCheckEducation = (key: string, item: TypeUseEducation, check: boolean) => {
        const tempCheckEducationList = { ...useCheckEducationList };
        const tempEducations = tempCheckEducationList[key].items;
        const temp = tempEducations.find((temp) => temp.name === item.name);
        if (temp !== undefined) temp.isChecked = check;

        setUseCheckEducationList(tempCheckEducationList);
    };

    useEffect(() => {
        if (useCheckEducationList === undefined) return;

        const unCheckedEducation = Object.keys(useCheckEducationList).find((category) =>
            useCheckEducationList[category].items.find((item) => item.isChecked === false)
        );

        if (unCheckedEducation === undefined) {
            Utils.triggerEvent(Common.EVENT_ENABLE_PROCESS_BUTTON, true);
        } else {
            Utils.triggerEvent(Common.EVENT_ENABLE_PROCESS_BUTTON, false);
        }
    }, [useCheckEducationList]);

    const displayEducations = () => {
        if (useCheckEducationList === undefined) return null;

        return Object.keys(useCheckEducationList).map((key, index) => {
            return (
                <div key={key}>
                    <Space key={key} direction="vertical" size={10} style={{ width: "100%" }}>
                        <h3 style={{ margin: 0 }}>{useCheckEducationList[key].name}</h3>
                        {useCheckEducationList[key].items.map((item) => (
                            <Row key={item.name}>
                                <Checkbox
                                    className={styles.checkbox}
                                    checked={item.isChecked}
                                    onChange={(e) => setCheckEducation(key, item, e.target.checked)}
                                >
                                    {item.name}
                                </Checkbox>
                            </Row>
                        ))}
                    </Space>
                    {index === Object.length ? "" : <Divider className={styles.divider} />}
                </div>
            );
        });
    };

    const onAllCheck = (check: boolean) => {
        const tempCheckEducationList = { ...useCheckEducationList };
        Object.keys(tempCheckEducationList).forEach((key) => tempCheckEducationList[key].items.forEach((item) => (item.isChecked = check)));

        setUseCheckEducationList(tempCheckEducationList);
    };

    return (
        <PageContainer>
            <Space direction="vertical" size={20} style={{ width: "100%" }}>
                <Checkbox className={styles.checkbox} style={{ fontSize: "18px", fontWeight: "bold" }} onChange={(e) => onAllCheck(e.target.checked)}>
                    전체선택
                </Checkbox>
                {displayEducations()}
            </Space>
        </PageContainer>
    );
}

export default UseEducation;
